export const LuminorIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g id="Luminor">
        <rect id="Rectangle 485" width="40" height="40" rx="4" fill="#4B163B" />
        <g id="luminor-symbol-stone 1" clipPath="url(#clip0_203_1101)">
          <path
            id="Vector"
            d="M24.9955 14.0293L22.6405 11.676L20.2858 14.0293L22.6405 16.3824L24.9955 14.0293ZM18.3352 14.0293H15.0049V28.3403H24.9955V25.0138H18.3352V14.0293Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_203_1101">
          <rect
            width="10"
            height="16.6667"
            fill="white"
            transform="translate(15 11.6667)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
